// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1UfKZ","buttons":"RemoveExpirationActionButtons_buttons__3KnJS"};